import React from 'react';
import tinycolor2 from 'tinycolor2';
import classnames from 'classnames';

import ColorSelection from 'ub/ui/inline-text/color-selection';
import svgController from './state-controller';

import styles from './color-controls.scss';

class ColorControls extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      colorGroups: props.colorGroups,
    };

    this.changeHandler = this.changeHandler.bind(this);

    this.stateSubscription = svgController
      .stateChangedSubject
      .subscribe(this.setState.bind(this));
  }

  componentWillMount() {
    svgController
      .svgActionsSubject
      .onNext({type: 'setImage', value: this.state});
  }

  componentWillUnmount() {
    this.stateSubscription.dispose();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);

    svgController
      .svgActionsSubject
      .onNext({type: 'setImage', value: nextProps});
  }

  changeHandler(eventData) {
    svgController.svgActionsSubject.onNext(eventData);
  }

  getColorPickers(colorType) {
    const pickers = this.state.colorGroups.map(({id, color, type}) => {
      const colorObj = tinycolor2(color).toRgb();
      if (colorType === type) {
        const right = colorType === 'stroke' && this.hasType('fill') ? 'right' : '';
        return (
          <div key={id} className={classnames(styles.colorPicker, 'svg-color-picker', right)}>
            <ColorSelection
              id={id}
              color={colorObj}
              changeHandler={this.changeHandler}
              changeProperty="colorChange"
            />
          </div>
        );
      }
    });

    return (
      <div className={classnames(styles.itemContainer, 'input-group color-input-group')}>
        <label className={classnames(styles.label, 'form-elm-label')}>{colorType}</label>
        <div>
          {pickers}
        </div>
      </div>
    );
  }

  hasType(type) {
    return this.state.colorGroups.some(color => color.type === type);
  }

  render() {
    if (this.state.colorGroups) {
      return (
        <div className={classnames(styles.container, 'form-elm')}>
          {this.hasType('fill') ? this.getColorPickers('fill') : null}
          {this.hasType('stroke') ? this.getColorPickers('stroke') : null}
        </div>
      );
    } else {
      return null;
    }
  }
}

ColorControls.propTypes = {
  colorGroups: React.PropTypes.array
};

export default ColorControls;



// WEBPACK FOOTER //
// ./src/ui/svg/color-controls.jsx